import { useTimezoneSelect } from 'react-timezone-select';

export function useTimeZoneOptions() {
    const { options: timeZoneOptions } = useTimezoneSelect({});
    return timeZoneOptions;
}
